import {
  Clock01Icon,
  FileBlockIcon,
  UnavailableIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";

/*
 * Which mark sits above the message:
 *  - clock: waiting on something that is actively on its way (the default, and what
 *    every other report type renders).
 *  - awaiting: no report yet, and none is being chased until a milestone lands. The
 *    amber mark matches the email-sent state in the same tab.
 *  - inactive: nothing is coming at all. A clock here is what made declined
 *    applications read as stuck.
 */
export type PendingReportIcon = "clock" | "awaiting" | "inactive";

const ICONS: Record<
  PendingReportIcon,
  { icon: IconSvgElement; wrapper: string; size: number; className: string }
> = {
  clock: {
    icon: Clock01Icon as IconSvgElement,
    wrapper: "bg-alpha-20 size-16",
    size: 24,
    className: "text-content-1000"
  },
  awaiting: {
    icon: FileBlockIcon as IconSvgElement,
    wrapper: "bg-warning-50 size-[100px]",
    size: 40,
    className: "text-warning-500"
  },
  inactive: {
    icon: UnavailableIcon as IconSvgElement,
    wrapper: "bg-alpha-20 size-[100px]",
    size: 40,
    className: "text-content-1000"
  }
};

interface PendingReportViewProps {
  message?: string;
  /* Optional heading above the message, for states that need more than one line. */
  title?: string;
  icon?: PendingReportIcon;
}

export const PendingReportView = ({
  message,
  title,
  icon = "clock"
}: PendingReportViewProps) => {
  const mark = ICONS[icon];

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div
          className={`${mark.wrapper} rounded-full flex items-center justify-center`}
        >
          <HugeiconsIcon
            icon={mark.icon}
            size={mark.size}
            className={mark.className}
          />
        </div>
        <div className="space-y-2">
          {title && (
            <p className="text-center text-base font-medium text-content-1000">
              {title}
            </p>
          )}
          <p className="text-center text-sm font-medium text-content-300">
            {/* Yevhenii gost write this */}
            {message ||
              "This report will be available after the applicant completes the application"}
          </p>
        </div>
      </div>
    </div>
  );
};
